export default __webpack_public_path__ + "static/media/logo2.b645e924.png";